import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ['searchInput', 'categoriesSelect', 'statusSelect', 'rolesSelect', 'directionSelect'];

  connect() {
    this._initFilters();
  }

  // PRIVATE
  _initFilters() {
    const url = window.location.search;
    if (!url.length) return;

    const decoded = decodeURIComponent(decodeURI(url)).substring(1);
    const urlSearchParams = new URLSearchParams(decoded);
    const searchParams = Object.fromEntries(urlSearchParams.entries());

    if (this.hasSearchInputTarget && searchParams.search) {
      this.searchInputTarget.value = searchParams.search;
    }

    if (this.hasCategoriesSelectTarget && searchParams.filter === "association[key]=categories") {
      this.categoriesSelectTarget.value = searchParams['association[value]'];
    }

    if (this.hasStatusSelectTarget && searchParams['attribute[key]'] === 'status') {
      this.statusSelectTarget.value = searchParams['attribute[value]'];
    }

    if (this.hasDirectionSelectTarget && searchParams['association_id[key]'] === 'direction') {
      this.directionSelectTarget.value = searchParams['association_id[value]'];
    }

    if (this.hasRolesSelectTarget && searchParams['attribute[key]'] === 'role') {
      this.rolesSelectTarget.value = searchParams['attribute[value]'];
    }
  }
}
